import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { routeNames } from 'src/app/app-routing-names';
import { AuthType } from 'src/app/models/enums/auth-type';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { SessionIdService } from '../services/session-id/session-id.service';

@Injectable({
    providedIn: 'root'
})
export class InternalAuthenticationGuard {
    constructor(private readonly authenticationService: AuthenticationService,
        private readonly router: Router,
        private readonly sessionService: SessionIdService
    ) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.isAllowedNavigate(state);
    }

    public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.canActivate(route, state);
    }

    private async isAllowedNavigate(state: RouterStateSnapshot): Promise<boolean> {
        let hasValidAuth: boolean = false;
        const authType = this.sessionService.getAuthType();

        if (authType === AuthType.Internal) {
            hasValidAuth = true;

        } else if (authType === AuthType.External) {
            if (await this.getIsAgentView()) {
                this.router.navigate([routeNames.LOGIN], {
                    queryParams: {
                        return: state.url
                    }
                });
            } else {
                this.router.navigate([routeNames.SELECT_PRODUCT]);
            }
        } else {
            this.router.navigate([routeNames.LOGIN], {
                queryParams: {
                    return: state.url
                }
            });
        }
        return hasValidAuth
    }


    private async getIsAgentView(): Promise<boolean> {
        let result = await firstValueFrom(this.authenticationService.getIsAgentView());
        if (result === true) {
            return true;
        }
        return false;
    }
}
